import { create } from "zustand";

const useComments = create((set) => ({
  isOpen: false,
  id: null,
  onOpen: (id) => set({ isOpen: true, id: id }),
  onClose: () => set({isOpen: false, id: null}),
}))

export default useComments;